import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { ShelfService } from '../../../service/shelf/shelf.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9241',
  templateUrl: 'wa9241.component.html',
  styleUrls: ['wa9241.component.scss']
})
export class Wa9241Component implements OnInit {
  public componentTitle = 'WA9241:格納什器マスタ登録';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public shelfCd: FormControl;
  public shelfTx: FormControl;

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private shelfCdCls = '';
  private shelfTxCls = '';
  private delisizeNrCls = '';

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private ownerService: OwnerService,
    private shelfService: ShelfService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {

    this.shelfCd = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39Ex),
      Validators.maxLength(validation.shelfCd.maxLength)
    ]);
    this.shelfTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.shelfTx.maxLength)
    ]);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
     // this.shelfCdElement.nativeElement.focus();
      this.onView();
    }, 500);
  }

  onView() {}

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled) {
      return;
    }


    const shelfCd = this.shelfCd.value.trim();
    const shelfTx = this.shelfTx.value.trim();
    let errors = false;
    if (this.shelfCd.errors !== null) {
      this.shelfCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shelfTx.errors !== null) {
      this.shelfTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shelfService
      .post(shelfCd, shelfTx, 'wa9241')
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
      this.shelfCd.setValue('');
      this.shelfTx.setValue('');
      this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow) {
      return;
    }

    this.shelfCdCls = this.shelfCd.value === '' ? '' : (this.shelfCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.shelfTxCls = this.shelfTx.value === '' ? '' : (this.shelfTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled =
      ((this.shelfCdCls === this.STRINGS_ACTIVE) && (this.shelfTxCls === this.STRINGS_ACTIVE));
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9241/wa9241.component.ts